import { render } from "./cargo-v2-filter-section.vue?vue&type=template&id=6cb130ca&scoped=true&ts=true"
import script from "./cargo-v2-filter-section.vue?vue&type=script&lang=ts"
export * from "./cargo-v2-filter-section.vue?vue&type=script&lang=ts"

import "./cargo-v2-filter-section.vue?vue&type=style&index=0&id=6cb130ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb130ca"]])

export default __exports__